import { BiArrowBack } from "react-icons/bi";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import ConsultationQueries from "./query/consultationQueries";
import BusinessExperts from "./experts/businessExperts";

const tabBtnClass =
  "inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2";
const tabActiveClass = "border-lime-500 text-lime-500";
const tabBorderNoneClass = "border-transparent";
const TAB_QUERIES = "queries";
const TAB_EXPERTS = "experts";

function Consultation() {
    const { t } = useTranslation();
    const location = useLocation();
  const [defaultTab, setDefaultTab] = useState(location?.state?.from === 'expert' ? "experts" : "queries");
  const handleTabClick = (action, e) => {
    setDefaultTab(action);
  };

  return (
    <>
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            <div className="p-10 py-2 pt-4">
              <div className="flex border-b">
                <div className="">
                  <ul className="flex">
                    <li className="mr-0 xl:mr-5">
                      <button
                        onClick={handleTabClick.bind(this, TAB_QUERIES)}
                        className={classNames({
                          [tabBtnClass]: true,
                          [tabActiveClass]: defaultTab === TAB_QUERIES,
                          [tabBorderNoneClass]:
                            defaultTab !== TAB_QUERIES,
                        })}
                      >
                        {t("O_CONSULTATION_QUERY")}
                      </button>
                    </li>
                    <li className="mx-0 xl:mx-5">
                      <button
                        onClick={handleTabClick.bind(
                          this,
                          TAB_EXPERTS
                        )}
                        className={classNames({
                          [tabBtnClass]: true,
                          [tabActiveClass]: defaultTab === TAB_EXPERTS,
                          [tabBorderNoneClass]:
                            defaultTab !== TAB_EXPERTS,
                        })}
                      >
                        {t("O_BUSINESS_EXPERTS")}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              {defaultTab === TAB_QUERIES ? (
                <ConsultationQueries/>
              ) : (
                <BusinessExperts/>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Consultation;
